import { connect } from 'react-redux';
import { goBack } from 'connected-react-router';
import { injectIntl } from 'react-intl';

import { checkExternalInitialization } from 'shared/utils/externalLoginUtils';
import config from 'config';

import Page404 from './Page404';

const mapStateToProps = () => ({
  logoSrc: config.product_name === 'moh' ? '/assets/img/MoH_Logo.svg' : '/assets/img/logo-doctor-online.svg',
  logoAlt: config.product_name === 'moh' ? 'logo_MoH' : 'Online Doctor',
  isExternalInit: checkExternalInitialization(),
});

export default connect(
  mapStateToProps,
  { goBack },
)(injectIntl(Page404));
